export const abnSelectionMedicareOptions = [
  {
    label:
      "I want the service(s) listed above. You may ask to be paid if the claim is denied and I also want Medicare billed for an official decision on payment, which is sent to me on a Medicare Summary Notice (MSN). I understand that if Medicare doesn't pay, I am responsible for payment, but I can appeal to Medicare by following the directions on the MSN. If Medicare does pay, you will refund any payments I made to you, less co-pays or deductibles.",
    value: "billMedicare",
  },
  {
    label:
      "I want the service(s) listed above, but do not bill Medicare. I am responsible for payment and cannot appeal.",
    value: "selfPay",
  },
  {
    label:
      "I do not want the service(s) listed above. I am not responsible for payment and cannot appeal.",
    value: "declineService",
  },
];

export const abnSelectionCommercialOptions = [
  {
    title: "YES, I want to receive these items or services.",
    label:
      "I understand I may be asked to pay {{amount}} if the claim is denied and I also want my claim filed with my insurance on file.",
    value: "payNowAndFileInsurance",
  },
  {
    title: "YES, I want to receive these items or services.",
    label: `I want to proceed with the services listed above, but do NOT want to file charges with my insurance carrier. I understand and agree to be fully responsible for these services.

• The estimated cost for the services listed above is: {{amount}}
• I understand that it is due in full at least 2 (two) weeks prior to the scheduled date of service.`,
    value: "selfPayNoInsurance",
  },
  {
    title: "NO, I have decided not to receive these items or services.",
    label:
      "I will not receive these services. I understand with this choice, I am not responsible for payment, and I cannot appeal to see if insurance would cover them.",
    value: "declineWithoutFinancialResponsibility",
  },
];

export const medicareNote =
  "If you choose Option 1 or 2, we may help you to use any other insurance that you might have, but Medicare cannot require us to do this.";
